import { Component, Input, Output, OnInit, inject, DestroyRef } from '@angular/core';
import { BaseComponent } from '../base/base/base-component.component';
import { Subject, debounceTime } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-number-input',
    template: `
        <div class="d-flex flex-row gap-1 w-50">
            <input type="number" class="form-control" [value]="data?.value" (input)="onInputChange($event)" />
        </div>
    `,
    standalone: false,
})
export class NumberInputComponent extends BaseComponent implements OnInit {
    @Output() emitter = new Subject<any>();
    @Input() data: any = {};

    private inputSubject = new Subject<number>();
    private destroyRef = inject(DestroyRef);

    ngOnInit() {
        if (!this.data.isValueEnabled) {
            this.data.value = '';
        }

        this.inputSubject.pipe(debounceTime(500), takeUntilDestroyed(this.destroyRef)).subscribe(val => {
            this.emitter.next({
                action: 'edit',
                data: this.data,
                value: val,
            });
        });
    }

    onInputChange(event: any) {
        const rawValue = event.target.value;
        const numericValue = rawValue === '' ? null : Number(rawValue);
        this.inputSubject.next(numericValue);
    }
}
